<template>
  <div>
    <el-button
        @click="() => {
          $router.back()
        }"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
      返回
    </el-button>
    <div class="academy-task-detail">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="180px"
        class="ruleForm"
        disabled
      >
        <div>
          <el-form-item
            v-for="item in formList"
            :key="item.key"
            :label="item.label + '：'"
          >
            {{ ruleForm[item.key] || '-' }}
          </el-form-item>
        </div>
        <el-form-item label="数字拜访途径：">微信</el-form-item>
        <el-form-item label="拜访时间：">
          {{ ruleForm.visitDt | transMonth }}
        </el-form-item>
        <el-form-item label="客户反馈时间：">
          {{ ruleForm.feedbackDt | transMonth }}
        </el-form-item>
        <el-form-item label="客户反馈：">
          {{ ruleForm.feedbackContent }}
        </el-form-item>
        <el-form-item label="传递信息：">
          <ul>
            <li
              v-for="item in ruleForm.transmitList"
              :key="item.id"
              class="listItem"
            >
              <el-link type="primary" @click="openPreview(1)">
                {{ item.informationName }}
              </el-link>
            </li>
          </ul>
        </el-form-item>
        <div class="form-item">
          <el-form-item label="信息反馈记录：">
            <el-image
              :src="ruleForm.feedbackUrl"
              :preview-src-list="[ruleForm.feedbackUrl]"
            >
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
          </el-form-item>
          <el-form-item label="信息转发记录：">
            <el-image
              :src="ruleForm.forwardUrl"
              :preview-src-list="[ruleForm.forwardUrl]"
            >
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog title="预览" :visible.sync="dialogVisible" width="1000px">
        <div class="preview">
          <iframe
            id="iframe"
            :src="ifrSrc"
            frameborder="0"
            scrolling="no"
            v-if="dialogVisible"
            @load="iframeLoad"
            width="375px"
            :height="ifrHeight"
          ></iframe>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { btLoading } from '@/Mixin/btLoading';
import { project } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import clientMapping from './clientMapping';

export default {
  mixins: [btLoading],
  data() {
    return {
      carouselIndex: 0,
      imagesList: [],
      dialogVisible: false,
      ifrSrc: '',
      ifrHeight: '800px', // iframe 高度
      ruleForm: {
        enterpriseId: '',
        projectName: '',
        bgUrl: '',
        commonName: '',
        competitorList: [''],
        approvalNumber: '',
        guige: '',
        jixing: '',
        price: '',
        yuanPrice: ''
      },
      imgList: [],
      type: this.$route.query.szVisitType
    };
  },
  components: {
    dicSelect,
    UploadImgOne
  },
  filters: {
    transDuty(val) {
      let arr = ['店长', '副店长', '店员', '业务员', '采购', '其他'];
      let returnVal = arr[val - 1] || '';
      return returnVal;
    },
    transStatus(val) {
      if (val == 1) {
        return '优秀';
      } else if (val == 2) {
        return '合格';
      } else if (val == 3) {
        return '不合格';
      }
    },
    transAuditStatus(val) {
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    }
  },
  methods: {
    iframeLoad() {
      this.$nextTick(_ => {
        let ifrDom = document.getElementById('iframe');
        setTimeout(_ => {
          this.ifrHeight =
            ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        }, 1500);
      });
    },
    openPreview(type) {
      if (type == 1) {
        this.ifrSrc = `${this.$Config.webViewUrl}${this.$Config.webPath}/visit?id=${this.$route.query.detailId}&platform=oss`;
      } else if (type == 2) {
        this.ifrSrc = `${this.$Config.webViewUrl}${this.$Config.webPath}/visit?id=${this.$route.query.detailId}&showType=feedback&platform=oss`;
      } else {
        this.ifrSrc = `${this.$Config.webViewUrl}${this.$Config.webPath}/visitDetail?id=${this.$route.query.detailId}&platform=oss`;
      }
      this.dialogVisible = true;
    }
  },
  computed: {
    formList() {
      return clientMapping[this.type];
    }
  },
  watch: {},
  created() {
    if (this.$route.query.id) {
      let { proId, visitTime } = this.$route.query;
      project
        .visitPlanDetail({
          id: proId
        })
        .then(res => {
          const info = res.data.data.numberVisit;
          this.ruleForm = info;
          this.ruleForm.transmitList =
            res.data.data.saasNumberVisitTransmitMessageList;
        });
    }
  }
};
</script>
<style lang="scss">
.academy-task-detail {
  .el-form-item__label {
    color: #bfbfbf;
  }
}
</style>
<style lang="scss" scoped>
.modal-box {
  width: 100%;
  height: 100%;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
.graph-pic {
  margin-top: 13px;
  max-height: 132px;
}

.img-group {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;

  img {
    max-height: 132px;
    margin-bottom: 15px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.form-item {
  display: flex;
  max-width: 1000px;
  .el-form-item {
    width: 50%;
  }
}
.listItem {
  list-style: disc;
  color: #1890ff;
}
</style>
